import { Button } from "@/components/ui/button"
import { useNapForm } from "../NapFormContext"
import { LookupItem } from "@/types/activity"
import { Bed } from "lucide-react"

interface OnsetStepProps {
  onsetMethods: LookupItem[]
  childName?: string
  onNext: () => void
  onPrev?: () => void
}

export function OnsetStep({ onsetMethods, childName, onNext, onPrev }: OnsetStepProps) {
  // Access form through context
  const form = useNapForm();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-center text-blue-300 mb-5">
        How did {childName || 'your baby'} fall asleep?
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
        {onsetMethods.map((method) => (
          <Button
            key={method.id}
            type="button"
            variant={form.watch("onset_method_id") === method.id ? "default" : "outline"}
            className={`w-full py-3 px-4 h-auto text-left justify-start whitespace-normal transition-all duration-200 ${
              form.watch("onset_method_id") === method.id 
                ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-md" 
                : "bg-slate-800 border-slate-600 text-slate-300 hover:bg-slate-700 hover:text-white"
            }`}
            onClick={() => {
              form.setValue("onset_method_id", method.id)
              form.clearErrors("onset_method_id")
              onNext()
            }}
          >
            <Bed className={`mr-2 h-4 w-4 shrink-0 ${form.watch("onset_method_id") === method.id ? "text-blue-200" : "text-blue-400"}`} />
            <span className="text-sm line-clamp-2">{method.name || method.description || method.id}</span>
          </Button>
        ))}
      </div>
      
      {form.formState.errors.onset_method_id && (
        <p className="text-sm text-red-400 bg-red-900/20 p-2 rounded border border-red-800/30 mt-2">
          {form.formState.errors.onset_method_id.message}
        </p>
      )}
      
      <div className="flex justify-between pt-4">
        {onPrev && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onPrev}
            className="border-slate-600 bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
          >
            Back
          </Button>
        )}
        
        <Button
          type="button"
          onClick={() => onNext()}
          className="ml-auto bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white shadow-md"
        >
          Skip
        </Button>
      </div>
    </div>
  )
}